export const RESET = 'EXCMSLA_UPDATE_RESET'
export const SET_ERROR = 'EXCMSLA_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMSLA_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMSLA_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMSLA_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMSLA_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMSLA_UPDATE_UPDATE_RETRIEVED'
